module.exports = __webpack_public_path__ + "img/ell_custom_icon.96741476.png";